import { useNavigate, useParams } from 'react-router'
import { Card, EmptyState, Skeleton, Tabs } from '../ui'
import { useSession } from '../lib/session'
import { Page } from './Page'
import { OverviewTab } from './admin/OverviewTab'
import { LiveRatesTab } from './admin/LiveRatesTab'
import { UsersTab } from './admin/UsersTab'
import { PipelineTab } from './admin/PipelineTab'
import { SystemTab } from './admin/SystemTab'
import { BillingTab } from './admin/BillingTab'
import { SettingsTab } from './admin/SettingsTab'
import { RankedTab } from './admin/RankedTab'
import styles from './admin/admin.module.css'

const TABS = [
  { id: 'overview', label: 'Overview', subtitle: 'Users, filings, alerts and system health at a glance.', el: <OverviewTab /> },
  { id: 'live', label: 'Live rates', subtitle: 'Switch live prices on or off, watch the Dhan feed and check any symbol.', el: <LiveRatesTab /> },
  { id: 'ranked', label: 'Ranked', subtitle: 'Track record of Ranked trade ideas, invited users and alert deliveries.', el: <RankedTab /> },
  { id: 'users', label: 'Users', subtitle: 'Find users, change roles, suspend accounts and end sessions.', el: <UsersTab /> },
  { id: 'pipeline', label: 'Filings & alerts', subtitle: 'Exchange → BCEIE → classifier → alert latency and delivery health.', el: <PipelineTab /> },
  { id: 'system', label: 'System', subtitle: 'Processes, uptime, certificates and errors.', el: <SystemTab /> },
  { id: 'billing', label: 'Billing', subtitle: 'MRR, trials, churn and failed payments.', el: <BillingTab /> },
  { id: 'settings', label: 'Settings', subtitle: 'Launch offer, runtime switches and the admin activity log.', el: <SettingsTab /> },
] as const

/** Admin console at /admin/:tab (admins only). */
export function AdminPage() {
  const { me } = useSession()
  const { tab = 'overview' } = useParams()
  const navigate = useNavigate()
  const current = TABS.find(t => t.id === tab) ?? TABS[0]
  if (me === undefined) return <Page title="Admin"><Card><Skeleton lines={3} label="Checking access" /></Card></Page>
  if (me?.user.role !== 'admin') return <Page title="Admin"><Card variant="flush"><EmptyState kind="error" title="Admins only" /></Card></Page>
  return (
    <Page title={`Admin · ${current.label}`} subtitle={current.subtitle} wide>
      <div className={styles.shell}>
        <div className={styles.tabsRow}>
          <Tabs label="Admin sections" tabs={TABS.map(t => ({ id: t.id, label: t.label }))} value={current.id}
            onChange={id => navigate(id === 'overview' ? '/admin' : `/admin/${id}`)} controls="admin-panel" />
        </div>
        <div id="admin-panel" role="tabpanel" aria-label={current.label}>{current.el}</div>
      </div>
    </Page>
  )
}
